import { type ShoppingCart } from "@/services/marketplace/cart";
import { type ShippingMethod } from "@/services/marketplace/shippingMethod";
import { type Ref } from "vue";

export function useIsShippingMethodSelected(cart: Ref<ShoppingCart | undefined>, shippingMethod: ShippingMethod) {
  return computed(() => cart.value?.selectedShippingMethod?.id === shippingMethod.id);
}
